import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Profile } from '@par/shared/types/player';
import { fetchGet } from '../api/common';
import { AllPlayers } from '../components/admin/AllPlayers';

type PropTypes = {
  close: () => void;
  handleResetPlayer: (profileId: string) => void;
  open: boolean;
};

export const AdminAllPlayersDialog = ({
  close,
  handleResetPlayer,
  open,
}: PropTypes) => {
  const [users, setUsers] = useState<Profile[]>();

  useEffect(() => {
    if (!open) return;

    fetchAllPlayers();
  }, [open]);

  const fetchAllPlayers = async () => {
    const res = await fetchGet('/admin');
    if (res) {
      setUsers(res.users);
    }
  };
  return (
    <Dialog open={open} onClose={close} maxWidth="xl" fullWidth>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <AllPlayers
          handleResetPlayer={handleResetPlayer}
          users={users}
        ></AllPlayers>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};
